class SubmenuManager {
	constructor() {
		this._init()
	}
	_init() {
		const els = document.querySelectorAll('[data-submenu]')
		this.els = [].map.call(els, el => new Submenu(el, this))
	}
	onChange(elChanged) {
		this.els.forEach(element => {
			if(element !== elChanged) {
				element.close()
			}
		})
	}
}

class Submenu {
	constructor(el, parent) {
		this.el = el
		this.parent = parent
		this._init()
	}
	_init() {
		this.el.querySelector('[data-submenu-action]').addEventListener("click", () => this.onClick())
		window.addEventListener("resize", () => this.onResize())
		this.onResize()
	}
	onResize() {
		if(this.isDesktop()) {
			this.open()
		} else {
			this.close()
		}
	}
	isDesktop() {
		return window.matchMedia("only screen and (min-width: 1024px)").matches
	}
	onClick() {
		if(this.isDesktop()) {
			return
		}
		if(this.isOpen()) {
			this.close()
		} else {
			this.parent.onChange(this)
			this.open()
		}
	}
	isOpen() {
		return this.el.classList.contains("header-nav__subcategory-is-open")
	}
	open() {
		this.el.classList.add("header-nav__subcategory-is-open")
		this.el.setAttribute('open', '')
	}
	close() {
		this.el.classList.remove("header-nav__subcategory-is-open")
		this.el.removeAttribute("open")
	}
}

export default SubmenuManager